var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAddToFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1H3C1.9 1 1 1.9 1 3V19L8 16L15 19V3C15 1.9 14.1 1 13 1Z",
    stroke: "#99C540"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddToFav);
export default __webpack_public_path__ + "static/media/icon_add_to_fav.4dffc7b39cf6f6b40d1bb0fc35808f26.svg";
export { ForwardRef as ReactComponent };